import { render } from "./iot-tab-2.vue?vue&type=template&id=4f7f1f27"
import script from "./iot-tab-2.vue?vue&type=script&lang=js"
export * from "./iot-tab-2.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__